module.exports = __webpack_public_path__ + "static/media/gremlin_draining.6320123f.jpg";